import React from 'react'
import styled from 'styled-components'

import useFaqData from '../../../../cmsHooks/useFaqData'

const List = styled.ul`
  list-style-type: none;
  margin: 0px;
  padding: 0px;
  margin-top: 40px;
`
const ListItem = styled.li`
  &:not(:last-child) {
    margin-bottom: 30px;
  }
  h3 {
    font-size: 24px;
    font-family: 'Open Sans', Arial, Helvetica, sans-serif;
  }
`
const Question = styled.h3``

const Answer = styled.p`
  font-size: 22px;
  margin-top: 10px;
`

const FAQ = (): JSX.Element => {
  const nodeList = useFaqData()

  return (
    <List>
      {nodeList.nodes.map(node => {
        const data = node.data
        return (
          <ListItem key={data.Question}>
            <Question>{data.Question}</Question>
            <Answer>{data.Answer}</Answer>
          </ListItem>
        )
      })}
    </List>
  )
}

export default FAQ
